import { Controller, useForm } from "react-hook-form";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";

type shareIfateProps = {
  setShareIfate: (val: boolean) => void;
  shareIfate: boolean;
};

export const ShareIFate: React.FC<shareIfateProps> = ({
  setShareIfate,
  shareIfate,
}) => {
  const { control } = useForm();
  return (
    <Grid item xs={12}>
      <Controller
        name="shareIFate"
        control={control}
        render={() => (
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => {
                  setShareIfate(e.target.checked);
                }}
                checked={shareIfate}
                data-test="shareIFate-apq"
              />
            }
            label="Share with IfATE"
          />
        )}
      />
    </Grid>
  );
};
